module.exports = ".pop-up {\n  background: white;\n  max-width: 1000px;\n  margin: 0 auto;\n  min-height: 300px;\n  border: 0px !important;\n  border-radius: 0.4rem; }\n\n.modal-body {\n  font-size: 1.3rem;\n  text-align: center;\n  color: #9b9b9b;\n  margin-top: -30px;\n  padding: 120px 30px 80px 30px; }\n\n.modal-button {\n  text-align: center;\n  bottom: 0;\n  left: 0;\n  right: 0; }\n\n.modal-button .btn-pop-up {\n    margin-bottom: 34px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/pop-up-html/pop-up-html.component.scss
// module id = ./src/app/shared/components/pop-up-html/pop-up-html.component.scss
// module chunks = main